import { $app, h, fill, auth, api, toast, go, setRender, fmtDate, topbar, PERM_LABEL, STATION } from './ui.js';
import { viewSession } from './station.js';
import { APP, chooseServer } from './native.js';

let current = null; // cleanup fn of the current view
function render() {
  current?.();
  current = null;
  $app.replaceChildren();
  document.body.className = '';
  const [, route, arg] = location.hash.match(/^#\/([^/]*)\/?(.*)$/) || [];
  if (route === 'invite') return viewInvite(...arg.split('?'));
  if (route === 'reset') return viewReset(arg);
  if (!auth.token) return viewLogin();
  if (route === 'session') {
    stationAuto = false;
    return (current = viewSession(Number(arg), $app));
  }
  // the old web administration is now the Cloud Console (same UI as the Mac app)
  if (route === 'admin') return APP ? go('#/') : void (location.href = 'console/');
  if (route === 'download') return APP ? go('#/') : viewDownload();
  if (route === 'login') return viewLogin();
  return viewHome();
}
setRender(render);
window.addEventListener('hashchange', render);

function viewLogin() {
  const user = h('input', { id: 'login-user', name: 'username', autocomplete: 'username', placeholder: 'Username or email', autocapitalize: 'none', required: true });
  const pw = h('input', { id: 'login-pw', name: 'password', type: 'password', autocomplete: 'current-password', placeholder: 'Password', required: true });
  const accepted = h('input', { id: 'login-terms', type: 'checkbox', required: true });
  const form = h(
    'form',
    {
      class: 'card narrow',
      onsubmit: async (e) => {
        e.preventDefault();
        try {
          const r = await api('POST', 'login', { username: user.value, password: pw.value });
          auth.set(r.token, r.user);
          const next = sessionStorage.getItem('talk.next'); // e.g. back to the Cloud Console
          sessionStorage.removeItem('talk.next');
          if (!APP && next && r.user.producer) return void (location.href = next);
          go(sessionStorage.getItem('talk.after') || '#/');
          sessionStorage.removeItem('talk.after');
        } catch (err) {
          toast(err.message);
        }
      },
    },
    h('h1', {}, 'Sign in'),
    user,
    pw,
    h('label', { class: 'check small', for: 'login-terms' }, accepted, h('span', {}, 'I accept the ', h('a', { href: '/terms', target: '_blank', rel: 'noopener' }, 'Terms of Use'), ' and have read the ', h('a', { href: '/privacy', target: '_blank', rel: 'noopener' }, 'Privacy Policy'), '.')),
    h('button', { class: 'primary', type: 'submit' }, 'Sign in'),
    h('a', { href: '#', onclick: (e) => (e.preventDefault(), forgot(user.value)) }, 'Forgot password?'),
    h('p', { class: 'muted small' }, 'Access is available only with an account assigned by your production administrator.'),
    APP && h('p', { class: 'muted small' }, `Server: ${location.host} · `, h('a', { href: '#', onclick: (e) => (e.preventDefault(), chooseServer()) }, 'Change')),
  );
  $app.append(topbar(), h('main', { class: 'center login' }, h('img', { class: 'login-logo', src: 'logo.svg', alt: 'OUTSTANDING TALK', width: 2130, height: 1124 }), form, h('p', { class: 'powered' }, 'powered by ', h('b', {}, 'Outstanding Events'))));
  user.focus();
}

async function forgot(prefill) {
  const cfg = await api('GET', 'password/config').catch(() => ({ mail: false }));
  if (cfg.local) return toast('Local mode: a producer resets the password in the Mac app under “Users”.');
  if (!cfg.mail) return toast('Please ask an admin to create a reset link for you (Users).');
  const login = prompt('Username or email', prefill || '');
  if (!login) return;
  try {
    await api('POST', 'password/forgot', { login });
    toast('If an account with this email exists, a link is on its way.', 'ok');
  } catch (e) {
    toast(e.message);
  }
}

function viewReset(token) {
  const pw = h('input', { id: 'reset-pw', type: 'password', autocomplete: 'new-password', placeholder: 'New password (at least 12 characters)', minlength: 12, required: true });
  const pw2 = h('input', { id: 'reset-pw2', type: 'password', autocomplete: 'new-password', placeholder: 'Repeat password', required: true });
  const form = h(
    'form',
    {
      class: 'card narrow',
      onsubmit: async (e) => {
        e.preventDefault();
        if (pw.value !== pw2.value) return toast('The passwords do not match');
        try {
          await api('POST', 'password/reset', { token, password: pw.value });
          auth.clear();
          toast('Password changed – please sign in again', 'ok');
          go('#/login');
        } catch (err) {
          toast(err.message);
        }
      },
    },
    h('h1', {}, 'New password'),
    pw,
    pw2,
    h('button', { class: 'primary', type: 'submit' }, 'Save password'),
    h('p', { class: 'muted small' }, 'You will then be signed out on all devices.'),
  );
  $app.append(topbar(), h('main', { class: 'center' }, form));
  pw.focus();
}

async function viewInvite(code, query = '') {
  // ?name=…&auto=1: switching over from the other side of a hybrid session (name kept, joins right away)
  const q = new URLSearchParams(query);
  const card = h('div', { class: 'card narrow' }, 'Loading invite …');
  $app.append(topbar(), h('main', { class: 'center' }, card));
  let s;
  try {
    s = await api('GET', `invite/${code}`);
  } catch (e) {
    return fill(card, h('h1', {}, 'Invite'), h('p', {}, e.message));
  }
  const name = s.guestAccess && h('input', { id: 'guest-name', placeholder: 'Your name (e.g. Camera 2)', maxlength: 40, required: true, value: q.get('name') || null });
  const guestPw = s.guestAccess && s.guestPassword && h('input', { id: 'guest-pw', type: 'password', placeholder: 'Guest password', autocomplete: 'off', required: true });
  const loggedIn = auth.token && !auth.user?.guest;
  fill(
    card,
    h('h1', {}, s.name),
    h('p', { class: 'muted' }, s.status === 'running' ? 'Session is live' : `Session not started yet${s.scheduledAt ? ` · planned ${fmtDate(s.scheduledAt)}` : ''}`),
    loggedIn
      ? h('button', { class: 'primary', onclick: () => go(`#/session/${s.id}`) }, `Join as ${auth.user.name}`)
      : !s.guestAccess
        ? h('div', { class: 'stack' }, h('p', { class: 'muted' }, 'You need an OUTSTANDING TALK account assigned to this session.'), h('a', { class: 'btn primary', href: '#/login', onclick: () => sessionStorage.setItem('talk.after', `#/invite/${code}`) }, 'Sign in'))
        : h(
          'form',
          {
            class: 'stack',
            onsubmit: async (e) => {
              e.preventDefault();
              try {
                const r = await api('POST', `invite/${code}`, { name: name.value, password: guestPw?.value });
                auth.set(r.token, r.user);
                go(`#/session/${r.sessionId}`);
              } catch (err) {
                toast(err.message);
              }
            },
          },
          name,
          guestPw,
          h('button', { class: 'primary', type: 'submit' }, 'Join as guest'),
          h('a', { href: '#/login', onclick: () => sessionStorage.setItem('talk.after', `#/invite/${code}`) }, 'I have an account'),
        ),
  );
  // the join screen of the session still needs one tap (browsers only start audio after a user gesture)
  if (q.get('auto') && s.status === 'running') {
    if (loggedIn) go(`#/session/${s.id}`);
    else if (s.guestAccess && !s.guestPassword && name.value) card.querySelector('form')?.requestSubmit();
  }
}

async function viewDownload() {
  const card = h('div', { class: 'card download' }, h('p', { class: 'muted' }, 'Loading …'));
  $app.append(topbar(h('a', { class: 'btn ghost small', href: '#/' }, 'Sessions')), h('main', {}, card));
  let r;
  try {
    r = await api('GET', 'download/mac');
  } catch (e) {
    return fill(card, h('p', {}, e.message));
  }
  if (!r.available) return fill(card, h('h1', {}, 'OUTSTANDING TALK for Mac'), h('p', { class: 'muted' }, 'No version published yet.'));
  const mb = (r.size / 1e6).toFixed(0);
  const btn = h('button', {
    class: 'primary big',
    onclick: async () => {
      btn.disabled = true;
      try {
        const { url } = await api('POST', 'download/mac');
        location.href = url; // short-lived signed link → browser download
        toast('Download started', 'ok');
      } catch (e) {
        toast(e.message);
      }
      setTimeout(() => (btn.disabled = false), 3000);
    },
  }, `Download (${mb} MB)`);
  fill(
    card,
    h('div', { class: 'dl-head' }, h('img', { src: 'icon.svg', alt: '', width: 64, height: 64 }), h('div', {}, h('h1', {}, 'OUTSTANDING TALK'), h('p', { class: 'muted' }, `Version ${r.version} · for Macs with Apple Silicon · macOS ${r.minMacos} or later`))),
    h('p', {}, 'The production base for the director: run sessions, participants, tally (OBS, ATEM), program feed (NDI, SRT, capture cards), monitoring and panel. Everything is included – no further software required.'),
    btn,
    h('ol', { class: 'steps-list' },
      h('li', {}, 'Open the downloaded DMG and drag “OUTSTANDING TALK” into the Applications folder.'),
      h('li', {}, 'Start the app from Applications and allow local network access.'),
      h('li', {}, 'Create a pairing code (Console › Bases – admins only) and enter it in the app – or choose Local mode.'),
    ),
    h('p', { class: 'muted small' }, 'The app is notarized by Apple and updates itself automatically.'),
    h('details', {}, h('summary', { class: 'muted small' }, 'Checksum (SHA-256)'), h('code', { class: 'mono small sha' }, r.sha256)),
  );
}

/**
 * director panel in the Mac app: no list, no administration – one live session opens right away,
 * several ask once which one; none: wait until one goes live
 */
let stationAuto = true; // only on the first view (after "Leave" the choice is shown)
function viewStationHome() {
  const box = h('div', { class: 'card narrow station-pick' }, h('p', { class: 'muted' }, 'Looking for live sessions …'));
  $app.append(topbar(), h('main', { class: 'center' }, box));
  const open = (s) => go(`#/session/${s.id}`);
  const load = async () => {
    let live = [];
    try {
      live = (await api('GET', 'sessions')).filter((s) => s.status === 'running');
    } catch (e) {
      return fill(box, h('p', {}, e.message));
    }
    if (live.length === 1 && stationAuto) return ((stationAuto = false), open(live[0]));
    fill(
      box,
      h('h1', {}, live.length ? 'Which session do you want to open?' : 'No live session'),
      h('p', { class: 'muted small' }, `Signed in as ${auth.user?.name || auth.user?.username || '?'}`),
      !live.length && h('p', { class: 'muted' }, 'The panel opens as soon as a session goes live.'),
      ...live.map((s) => h('button', { class: 'pick', onclick: () => ((stationAuto = false), open(s)) }, h('span', { class: 'title' }, s.name), h('span', { class: 'muted small' }, [s.myRole && `your role: ${s.myRole}`, auth.user?.producer && `${s.participants} connected`].filter(Boolean).join(' · ') || 'live'))),
    );
  };
  load();
  const t = setInterval(load, 4000);
  current = () => clearInterval(t);
}

async function viewHome() {
  if (STATION || APP) return viewStationHome();
  const list = h('div', { class: 'list' }, h('p', { class: 'muted' }, 'Loading sessions …'));
  const u = auth.user;
  $app.append(
    topbar(u?.admin && !u.localMode && h('a', { class: 'btn ghost small', href: 'manager/' }, 'Manager'), u?.producer && !u.localMode && h('a', { class: 'btn primary small', href: 'console/' }, 'Cloud Console')),
    h('main', {}, h('div', { class: 'row head' }, h('h1', {}, u?.producer ? 'Sessions' : 'My sessions'), u?.perm && h('span', { class: `badge perm-${u.perm}` }, PERM_LABEL[u.perm])), list),
  );
  const load = async () => {
    try {
      const sessions = (await api('GET', 'sessions')).filter((s) => s.status !== 'ended');
      fill(
        list,
        !sessions.length && h('p', { class: 'empty' }, u?.producer ? 'No sessions planned.' : 'You are not in any session right now. A producer will add you.'),
        ...sessions.map((s) =>
          h(
            'article',
            { class: `item ${s.status}` },
            h(
              'div',
              { class: 'grow' },
              h('div', { class: 'title' }, s.name),
              h('div', { class: 'muted small' }, [s.status === 'running' ? 'live' : s.scheduledAt ? fmtDate(s.scheduledAt) : 'planned', s.myRole && `your role: ${s.myRole}`, s.myCam && `Tally ${s.myCam}`, u?.producer && s.status === 'running' && `${s.participants} connected`].filter(Boolean).join(' · ')),
            ),
            s.status === 'running' ? h('a', { class: 'btn primary', href: `#/session/${s.id}` }, 'Join') : h('span', { class: 'badge' }, 'not started yet'),
          ),
        ),
      );
    } catch (e) {
      fill(list, h('p', {}, e.message));
    }
  };
  load();
  const t = setInterval(load, 5000);
  current = () => clearInterval(t);
}

// refresh the stored profile (permissions may have changed since the last login)
if (auth.token && !auth.user?.guest)
  api('GET', 'me')
    .then((me) => {
      const before = JSON.stringify(auth.user);
      auth.setUser(me);
      if (before !== JSON.stringify(me) && !location.hash.startsWith('#/session')) render();
    })
    .catch(() => {});
render();
